import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { TrackerService } from '@shared/services/tracker.service';

@Component({
  selector: 'app-abandon-accounts',
  templateUrl: './abandon-accounts.component.html',
})
export class AbandonAccountsComponent implements OnChanges {
  constructor(private tracker: TrackerService) {}

  @Output() yesAbandon = new EventEmitter();
  @Output() noContinue = new EventEmitter();
  @Input() show = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.show?.previousValue === false && changes.show.currentValue === true) {
      this.tracker.trackPage({ taggingPage: 'ABANDON_BANK_CONNECTION' });
    }
  }

  emitYesAbandon() {
    this.tracker.trackClick({
      click: `${frenchi18n.common_yes}${frenchi18n.cancel_popin_refused_exit}`,
      taggingPage: 'ABANDON_BANK_CONNECTION',
    });

    this.yesAbandon.emit();
  }

  emitNoContinue() {
    this.tracker.trackClick({
      click: `${frenchi18n.common_no}${frenchi18n.cancel_popin_refused_continue}`,
      taggingPage: 'ABANDON_BANK_CONNECTION',
    });

    this.noContinue.emit();
  }
}
